import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "lucky-spin-invite-popup"
};
const _hoisted_2 = {
  class: "popup-main"
};
const _hoisted_3 = {
  class: "popup-header"
};
const _hoisted_4 = {
  class: "popup-title"
};
const _hoisted_5 = {
  class: "popup-content"
};
const _hoisted_6 = {
  class: "flex justify-center"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "spin-num"
}, "x1", -1);
const _hoisted_8 = {
  class: "invite-content"
};
const _hoisted_9 = {
  class: "invite-tip"
};
const _hoisted_10 = {
  class: "share-text"
};
import { useHelpTool } from '@/hooks';
export default {
  __name: 'Invite',
  emits: ['onClose'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const {
      doShare
    } = useHelpTool();
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_popup = _resolveComponent("van-popup");
      const _directive_audio = _resolveDirective("audio");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_popup, {
        show: true,
        "close-on-click-overlay": false,
        "lock-scroll": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('luckyWheel.invite.title')), 1), _withDirectives(_createVNode(_component_van_image, {
          class: "close-icon",
          src: require('@/assets/img/common/popup-close.png'),
          onClick: _cache[0] || (_cache[0] = $event => emit('onClose'))
        }, null, 8, ["src"]), [[_directive_audio, void 0, "close"]])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_van_image, {
          class: "spin-img",
          src: require('@/assets/img/lucky-spin/invite/spin.png')
        }, null, 8, ["src"]), _hoisted_7]), _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('luckyWheel.invite.inviteFriend').format({
          num: 1
        })), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('luckyWheel.invite.inviteFriendTip').format({
          num: 1
        })), 1), _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "share-btn",
          onClick: _cache[1] || (_cache[1] = (...args) => _unref(doShare) && _unref(doShare)(...args))
        }, [_createVNode(_component_van_image, {
          class: "share-img",
          src: require('@/assets/img/lucky-spin/invite/share.png')
        }, null, 8, ["src"]), _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('tabbar.share')), 1)])), [[_directive_audio]])])])]),
        _: 1
      })]);
    };
  }
};